export const environment = {
  production: true,
  backend: 'https://content.sqr.in.th',
  collectionType: [
    {value: 'collection', viewValue: 'collection'},
    {value: 'bundle', viewValue: 'bundle'}
  ],
  downloadable: [
    {value: true, viewValue: 'Yes'},
    {value: false, viewValue: 'No'},
  ]
};



// WEBPACK FOOTER //
// /app/src/environments/environment.ts